/* Treasure of India - theme.js
   All behaviour is null-guarded so each block only runs where its markup exists. */
(function () {
  "use strict";
  var body = document.body;

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector(".drawer"),
      backdrop = document.querySelector(".drawer-backdrop"),
      openBtns = document.querySelectorAll(".menu-toggle"),
      closeBtn = document.querySelector(".drawer-close");
  function setMenuExpanded(v) { openBtns.forEach(function (b) { b.setAttribute("aria-expanded", v ? "true" : "false"); }); }
  function openDrawer() { if (!drawer) return; drawer.classList.add("is-open"); if (backdrop) backdrop.classList.add("is-open"); setMenuExpanded(true); body.style.overflow = "hidden"; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove("is-open"); if (backdrop) backdrop.classList.remove("is-open"); setMenuExpanded(false); body.style.overflow = ""; }
  openBtns.forEach(function (b) { b.addEventListener("click", openDrawer); });
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);
  if (backdrop) backdrop.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) closeDrawer(); });
  document.querySelectorAll(".drawer-sub").forEach(function (dsub) {
    var t = dsub.querySelector(".drawer-sub-trigger");
    if (t) t.addEventListener("click", function () { dsub.classList.toggle("is-open"); });
  });

  /* ---------- Mega menus (desktop, supports multiple) ---------- */
  document.querySelectorAll(".has-mega").forEach(function (mega) {
    var megaBtn = mega.querySelector(".nav-trigger");
    if (!megaBtn) return;
    var mt;
    function setOpen(o) { mega.classList.toggle("is-open", o); megaBtn.setAttribute("aria-expanded", o); }
    mega.addEventListener("mouseenter", function () { clearTimeout(mt); setOpen(true); });
    mega.addEventListener("mouseleave", function () { mt = setTimeout(function () { setOpen(false); }, 120); });
    megaBtn.addEventListener("click", function (e) { e.preventDefault(); setOpen(!mega.classList.contains("is-open")); });
    document.addEventListener("click", function (e) { if (!mega.contains(e.target)) setOpen(false); });
  });

  /* ---------- Header scroll state ---------- */
  var siteHeader = document.querySelector(".site-header");
  function onScroll() { if (!siteHeader) return; if (window.scrollY > 40) siteHeader.classList.add("is-scrolled"); else siteHeader.classList.remove("is-scrolled"); }
  window.addEventListener("scroll", onScroll, { passive: true }); onScroll();

  /* ---------- Wishlist ----------
     v100: the visual-only toggle that used to live here has moved to
     assets/wishlist.js, which persists the list and drives the page at
     /pages/wishlist. Two listeners on the same button would double-toggle
     and cancel each other out, so nothing is bound here any more. */

  /* ---------- Hero video controls ---------- */
  var hv = document.querySelector(".hero-video"), pp = document.getElementById("vPlay"), mm = document.getElementById("vMute");
  function setUse(el, id) { var u = el.querySelector("use"); if (u) { u.setAttribute("href", id); u.setAttribute("xlink:href", id); } }
  if (hv && pp) pp.addEventListener("click", function () { if (hv.paused) { hv.play(); setUse(pp, "#i-pause"); } else { hv.pause(); setUse(pp, "#i-play"); } });
  if (hv && mm) mm.addEventListener("click", function () { hv.muted = !hv.muted; setUse(mm, hv.muted ? "#i-mute" : "#i-volume"); });

  /* ---------- YouTube lightbox ---------- */
  var yt = document.getElementById("ytLightbox"), ytClose = document.getElementById("ytClose"), ytFrame = document.getElementById("ytFrame");
  function openYT(e) { if (e) e.preventDefault(); if (!yt) return; var id = yt.getAttribute("data-yt") || "LXb3EKWsInQ"; ytFrame.src = "https://www.youtube.com/embed/" + id + "?autoplay=1&rel=0"; yt.classList.add("is-open"); body.style.overflow = "hidden"; }
  function closeYT() { if (!yt) return; ytFrame.src = ""; yt.classList.remove("is-open"); body.style.overflow = ""; }
  document.querySelectorAll(".yt-open").forEach(function (b) { b.addEventListener("click", openYT); });
  if (ytClose) ytClose.addEventListener("click", closeYT);
  if (yt) yt.addEventListener("click", function (e) { if (e.target === yt) closeYT(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeYT(); } });

  /* ---------- Product gallery ---------- */
  var gmain = document.getElementById("galleryMain");
  if (gmain) {
    document.querySelectorAll(".gallery-thumb").forEach(function (t) {
      t.addEventListener("click", function () {
        document.querySelectorAll(".gallery-thumb").forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
        var img = gmain.querySelector("img"), full = t.getAttribute("data-full");
        if (img && full) {
          img.style.opacity = "0";
          var swap = new Image();
          swap.onload = function () { img.src = full; img.srcset = ""; requestAnimationFrame(function () { img.style.opacity = "1"; }); };
          swap.src = full;
          var z = t.getAttribute("data-zoom"); if (z) gmain.setAttribute("data-zoom", z);
        }
        var mcls = t.getAttribute("data-media");
        if (mcls) { gmain.classList.remove("media-a", "media-b", "media-c", "media-d"); gmain.classList.add(mcls); }
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll("[data-qty-wrap]").forEach(function (wrap) {
    var input = wrap.querySelector("input"),
        minus = wrap.querySelector("[data-qty-minus]"),
        plus = wrap.querySelector("[data-qty-plus]");
    if (minus) minus.addEventListener("click", function () { input.value = Math.max(1, (+input.value || 1) - 1); });
    if (plus) plus.addEventListener("click", function () { input.value = Math.min(99, (+input.value || 1) + 1); });
  });

  /* ---------- Accordion ---------- */
  document.querySelectorAll(".acc-head").forEach(function (h) {
    h.addEventListener("click", function () { h.parentElement.classList.toggle("is-open"); });
  });

  /* ---------- Cart count + toast helpers ---------- */
  function updateCartCount(n) {
    document.querySelectorAll(".bag-count").forEach(function (bc) {
      bc.textContent = n;
      bc.style.display = n > 0 ? "flex" : "none";
    });
  }
  var toast = document.getElementById("toast");
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add("is-visible");
    setTimeout(function () { toast.classList.remove("is-visible"); }, 2400);
  }

  /* ---------- AJAX add to cart ---------- */
  document.querySelectorAll("form[data-product-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("[data-add-to-cart]");
      var original = btn ? btn.innerHTML : "";
      if (btn) { btn.disabled = true; btn.classList.add("is-loading"); }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          id: form.querySelector("[name=id]").value,
          quantity: parseInt((form.querySelector("[name=quantity]") || {}).value || 1, 10)
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          if (item && item.status) { showToast(item.description || "Could not add to bag"); }
          else { showToast("Added to your bag"); }
          return fetch("/cart.js").then(function (r) { return r.json(); });
        })
        .then(function (cart) { if (cart) updateCartCount(cart.item_count); })
        .catch(function () { showToast("Something went wrong"); })
        .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove("is-loading"); btn.innerHTML = original; } });
    });
  });

  /* ---------- Collection filters: auto-submit ---------- */
  var filterForm = document.getElementById("CollectionFilterForm");
  if (filterForm) {
    filterForm.querySelectorAll("input, select").forEach(function (el) {
      el.addEventListener("change", function () { filterForm.submit(); });
    });
    /* v109 — the filter panel is a drawer on every screen now, not just a
       mobile one, so it needs the same handling a drawer always needs:
       a veil, Escape, focus moved in and returned, and the page behind
       locked while it is open. */
    var mobToggle = document.getElementById("mobileFilterToggle");
    var panel = document.getElementById("filtersPanel");
    if (mobToggle && panel) {
      var veil = document.querySelector(".filters-veil");
      var lastFocus = null;

      function fOpen() {
        lastFocus = document.activeElement;
        panel.classList.add("is-open");
        if (veil) veil.hidden = false;
        mobToggle.setAttribute("aria-expanded", "true");
        document.body.style.overflow = "hidden";
        var first = panel.querySelector("input, select, a, button");
        if (first) first.focus();
        document.addEventListener("keydown", fKey);
      }
      function fClose() {
        panel.classList.remove("is-open");
        if (veil) veil.hidden = true;
        mobToggle.setAttribute("aria-expanded", "false");
        document.body.style.overflow = "";
        document.removeEventListener("keydown", fKey);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
      function fKey(e) { if (e.key === "Escape") fClose(); }

      mobToggle.addEventListener("click", function () {
        panel.classList.contains("is-open") ? fClose() : fOpen();
      });
      document.querySelectorAll("[data-filters-close]").forEach(function (b) {
        b.addEventListener("click", fClose);
      });
    }
  }

  /* ---------- Sort dropdown (collection) ---------- */
  var sortSelect = document.getElementById("sortSelect");
  if (sortSelect && !filterForm) {
    sortSelect.addEventListener("change", function () {
      var u = new URL(window.location.href);
      u.searchParams.set("sort_by", sortSelect.value);
      window.location.href = u.toString();
    });
  }
})();

/* ---------- Image slideshow ---------- */
(function () {
  "use strict";
  function initSlideshow(root) {
    if (root.dataset.slideshowInit) return;
    root.dataset.slideshowInit = "1";
    var slides = [].slice.call(root.querySelectorAll(".slide"));
    if (!slides.length) return;
    var dots = [].slice.call(root.querySelectorAll(".slideshow-dot"));
    var idx = 0, timer = null;
    var speed = (parseInt(root.getAttribute("data-speed") || "5", 10)) * 1000;
    var auto = root.getAttribute("data-autoplay") === "true";

    function go(n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle("is-active", i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle("is-active", i === idx); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (auto && slides.length > 1) { stop(); timer = setInterval(function () { go(idx + 1); }, speed); } }

    var next = root.querySelector(".slideshow-arrow.next"), prev = root.querySelector(".slideshow-arrow.prev");
    if (next) next.addEventListener("click", function () { go(idx + 1); start(); });
    if (prev) prev.addEventListener("click", function () { go(idx - 1); start(); });
    dots.forEach(function (d, i) { d.addEventListener("click", function () { go(i); start(); }); });
    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);

    var tx = null;
    root.addEventListener("touchstart", function (e) { tx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (tx === null) return;
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) { go(idx + (dx < 0 ? 1 : -1)); start(); }
      tx = null;
    }, { passive: true });

    root._slideshowGo = go;
    go(0); start();
  }

  function initAll(scope) { (scope || document).querySelectorAll("[data-slideshow]").forEach(initSlideshow); }
  initAll();

  /* Theme editor: re-init on section load, jump to selected slide block */
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:block:select", function (e) {
    var slide = e.target && e.target.closest ? e.target.closest(".slide") : null;
    if (!slide) return;
    var root = slide.closest("[data-slideshow]");
    if (!root || !root._slideshowGo) return;
    var slides = [].slice.call(root.querySelectorAll(".slide"));
    root._slideshowGo(slides.indexOf(slide));
  });
})();

/* ---------- Predictive search modal ---------- */
(function () {
  "use strict";
  var modal = document.getElementById("searchModal");
  if (!modal) return;
  var input = document.getElementById("searchModalInput");
  var results = document.getElementById("searchModalResults");
  var fmt = window.__moneyFormat || "₹{{amount}}";

  function esc(s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; }
  /* v96: esc() is for text nodes and leaves quotes intact, which is fine between
     tags but not inside an attribute. attr() escapes the quote characters too, and
     refuses anything that is not a same-origin path — so a crafted url or image
     field coming back from the search endpoint cannot break out of href="..." or
     introduce a javascript: target. */
  function attr(v) {
    v = String(v == null ? "" : v);
    if (!/^(\/(?!\/)|https:\/\/)/.test(v)) { return ""; }
    return v.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  function money(v) {
    var n = Number(v);
    var s = isNaN(n) ? esc(v) : n.toLocaleString("en-IN", { maximumFractionDigits: 2 });
    return fmt.replace(/\{\{[^}]*\}\}/, s);
  }
  function hint() { results.innerHTML = '<div class="sr-hint">Start typing to search pieces, collections and more.</div>'; }
  function open(e) { if (e) e.preventDefault(); modal.classList.add("is-open"); document.body.style.overflow = "hidden"; hint(); setTimeout(function () { input.focus(); }, 60); }
  function close() { if (!modal.classList.contains("is-open")) return; modal.classList.remove("is-open"); document.body.style.overflow = ""; }

  document.querySelectorAll(".search-open").forEach(function (b) { b.addEventListener("click", open); });
  modal.querySelectorAll("[data-search-close]").forEach(function (b) { b.addEventListener("click", close); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

  var t = null;
  input.addEventListener("input", function () {
    clearTimeout(t);
    var q = input.value.trim();
    if (q.length < 2) { hint(); return; }
    t = setTimeout(function () { fetchResults(q); }, 250);
  });

  function fetchResults(q) {
    var url = "/search/suggest.json?q=" + encodeURIComponent(q) +
      "&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last";
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (input.value.trim() !== q) return; // stale response
        var res = (data && data.resources && data.resources.results) || {};
        var prods = res.products || [], cols = res.collections || [];
        if (!prods.length && !cols.length) {
          results.innerHTML = '<div class="sr-empty">No results for &ldquo;' + esc(q) + '&rdquo;. Try another word.</div>';
          return;
        }
        var h = "";
        if (prods.length) {
          h += '<div class="sr-group">Pieces</div>';
          prods.forEach(function (p) {
            var img = (p.featured_image && p.featured_image.url)
              ? '<img src="' + attr(p.featured_image.url) + '" alt="" loading="lazy">'
              : '<svg class="icon" style="width:20px;height:20px"><use href="#i-artifact" xlink:href="#i-artifact"/></svg>';
            h += '<a class="sr-item" href="' + attr(p.url) + '"><span class="sr-thumb">' + img + '</span><span class="sr-title">' + esc(p.title) + '</span><span class="sr-price">' + money(p.price) + '</span></a>';
          });
        }
        if (cols.length) {
          h += '<div class="sr-group">Collections</div>';
          cols.forEach(function (c) {
            h += '<a class="sr-item" href="' + attr(c.url) + '"><span class="sr-thumb"><svg class="icon" style="width:18px;height:18px"><use href="#i-artifact" xlink:href="#i-artifact"/></svg></span><span class="sr-title">' + esc(c.title) + '</span></a>';
          });
        }
        h += '<a class="sr-all" href="/search?q=' + encodeURIComponent(q) + '">View all results for &ldquo;' + esc(q) + '&rdquo;</a>';
        results.innerHTML = h;
      })
      .catch(function () { results.innerHTML = '<div class="sr-empty">Search is unavailable right now.</div>'; });
  }
})();

/* ---------- Arch featured carousel (infinite loop) + quick add ---------- */
(function () {
  "use strict";
  function updateBag(n) { document.querySelectorAll(".bag-count").forEach(function (bc) { bc.textContent = n; bc.style.display = n > 0 ? "flex" : "none"; }); }
  function toast(msg) { var t = document.getElementById("toast"); if (!t) return; t.textContent = msg; t.classList.add("is-visible"); setTimeout(function () { t.classList.remove("is-visible"); }, 2400); }

  function init(root) {
    if (root.dataset.archInit) return;
    root.dataset.archInit = "1";
    var track = root.querySelector(".arch-track");
    var viewport = root.querySelector(".arch-viewport");
    if (!track || !viewport) return;
    var originals = [].slice.call(track.querySelectorAll(".arch-card"));
    var setLen = originals.length;
    if (!setLen) return;

    var loop = setLen > 1 && root.getAttribute("data-loop") !== "false";
    var copies = 0;
    if (loop) {
      /* clone whole sets on both sides so the viewport always has cards */
      var setW = Math.max(track.scrollWidth, 1);
      copies = Math.max(1, Math.ceil(viewport.clientWidth / setW));
      for (var k = 0; k < copies; k++) {
        for (var a = setLen - 1; a >= 0; a--) track.insertBefore(originals[a].cloneNode(true), track.firstChild);
        for (var b = 0; b < setLen; b++) track.appendChild(originals[b].cloneNode(true));
      }
    }
    var cards = [].slice.call(track.querySelectorAll(".arch-card"));
    var middleStart = copies * setLen;
    var idx = middleStart + Math.floor(setLen / 2);
    var busy = false;

    function applyActive() { cards.forEach(function (c, i) { c.classList.toggle("is-active", i === idx); }); }
    function center(noAnim) {
      var c = cards[idx];
      if (!c) return;
      if (noAnim) track.style.transition = "none";
      var off = c.offsetLeft + c.offsetWidth / 2 - viewport.clientWidth / 2;
      track.style.transform = "translateX(" + (-off) + "px)";
      if (noAnim) { void track.offsetWidth; track.style.transition = ""; }
    }
    function normalize() {
      /* after moving into a cloned set, jump back to the same card in the middle set */
      if (!loop) return;
      if (idx >= middleStart && idx < middleStart + setLen) return;
      var rel = ((idx - middleStart) % setLen + setLen) % setLen;
      idx = middleStart + rel;
      root.classList.add("arch-noanim");
      applyActive(); center(true);
      void track.offsetWidth;
      root.classList.remove("arch-noanim");
    }
    function update() {
      applyActive(); center(false);
      setTimeout(function () { center(false); }, 560);
      setTimeout(function () { normalize(); busy = false; }, 640);
    }
    function goTo(n) {
      if (busy) return;
      busy = true;
      idx = loop ? n : Math.max(0, Math.min(cards.length - 1, n));
      update();
    }

    var prev = root.querySelector(".arch-arrow.prev"), next = root.querySelector(".arch-arrow.next");
    if (prev) prev.addEventListener("click", function () { goTo(idx - 1); });
    if (next) next.addEventListener("click", function () { goTo(idx + 1); });

    /* clicking a card always follows its link — carousel rotates via
       arrows and swipe only (was hijacking clicks and blocking PDP) */

    var tx = null;
    root.addEventListener("touchstart", function (e) { tx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (tx === null) return;
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) goTo(idx + (dx < 0 ? 1 : -1));
      tx = null;
    }, { passive: true });

    window.addEventListener("resize", function () { center(true); });
    applyActive(); center(true);
    setTimeout(function () { center(true); }, 60);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { center(true); });
  }
  function initAll(scope) { (scope || document).querySelectorAll("[data-arch]").forEach(init); }
  initAll();
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });

  /* quick add: any [data-quick-add] button, including cloned cards */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-quick-add]");
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: Number(btn.getAttribute("data-quick-add")), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (item && item.status) { toast(item.description || "Could not add to bag"); }
        else { toast("Added to your bag"); }
        return fetch("/cart.js").then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) updateBag(cart.item_count); })
      .catch(function () { toast("Something went wrong"); })
      .finally(function () { btn.disabled = false; });
  });
})();

/* ---------- Scroll reveal ---------- */
(function () {
  "use strict";
  if (!("IntersectionObserver" in window)) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  document.documentElement.classList.add("js-anim");
  /* v154 — this script is deferred, so the first screen has already painted
     by the time it runs. Hiding an element that is on screen makes it blink
     out and fade back in ("content disappears, then the animation loads
     again", worst on phones). Anything already inside the viewport is left
     exactly as painted; only elements still below the fold are hidden and
     observed. On phones the trigger zone is wider and there is no stagger,
     so cards are ready the moment they scroll in. */
  var mobile = window.matchMedia && window.matchMedia("(max-width: 720px)").matches;
  var vh = window.innerHeight;
  var items = document.querySelectorAll(".product-card, .craft-card, .circle-cat, .blog-card, .value-card, .event-card, .col-tile, .master-card, .trust-item");
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add("in-view");
        en.target.style.transitionDelay = "";
        io.unobserve(en.target);
      }
    });
  }, mobile ? { rootMargin: "0px 0px 60px 0px", threshold: 0.01 } : { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
  items.forEach(function (el, i) {
    var r = el.getBoundingClientRect();
    if (r.top < vh && r.bottom > 0) return;   /* already visible: never hide it */
    el.classList.add("anim-item");
    if (!mobile) el.style.transitionDelay = (i % 4) * 70 + "ms";
    io.observe(el);
  });
})();

/* ---------- Cart quantity steppers (auto update) ---------- */
(function () {
  "use strict";
  var form = document.getElementById("CartForm");
  if (!form) return;
  var t;
  function submitSoon() { clearTimeout(t); t = setTimeout(function () { form.submit(); }, 450); }
  form.querySelectorAll("[data-cart-qty]").forEach(function (w) {
    var input = w.querySelector("input");
    var m = w.querySelector("[data-cart-minus]"), p = w.querySelector("[data-cart-plus]");
    if (m) m.addEventListener("click", function () { input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1); submitSoon(); });
    if (p) p.addEventListener("click", function () { input.value = Math.min(99, (parseInt(input.value, 10) || 0) + 1); submitSoon(); });
    input.addEventListener("change", submitSoon);
  });
})();

/* ---------- Product image zoom + lightbox ---------- */
(function () {
  "use strict";
  var main = document.getElementById("galleryMain");
  if (!main) return;
  var canHover = window.matchMedia && window.matchMedia("(hover:hover) and (pointer:fine)").matches;

  /* hover pan-zoom (desktop) */
  if (canHover && main.getAttribute("data-zoom")) {
    main.classList.add("zoomable");
    main.addEventListener("mousemove", function (e) {
      var im = main.querySelector("img");
      if (!im) return;
      var r = main.getBoundingClientRect();
      im.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + "% " + ((e.clientY - r.top) / r.height) * 100 + "%";
    });
    main.addEventListener("mouseenter", function () { main.classList.add("is-zooming"); });
    main.addEventListener("mouseleave", function () {
      main.classList.remove("is-zooming");
      var im = main.querySelector("img");
      if (im) im.style.transformOrigin = "center center";
    });
  }

  /* fullscreen lightbox */
  var lb = document.getElementById("imgLightbox");
  if (!lb) return;
  var ilImg = document.getElementById("ilImage");
  var sources = [], cur = 0;

  function collect() {
    sources = [];
    var thumbs = document.querySelectorAll(".gallery-thumb");
    if (thumbs.length) {
      thumbs.forEach(function (t) { var s = t.getAttribute("data-zoom") || t.getAttribute("data-full"); if (s) sources.push(s); });
    } else {
      var s = main.getAttribute("data-zoom");
      if (s) sources = [s];
    }
  }
  function show(i) {
    if (!sources.length) return;
    cur = (i + sources.length) % sources.length;
    ilImg.src = sources[cur];
  }
  function openLB() {
    if (!main.getAttribute("data-zoom")) return;
    collect();
    var idx = sources.indexOf(main.getAttribute("data-zoom"));
    lb.classList.add("is-open");
    document.body.style.overflow = "hidden";
    show(idx > -1 ? idx : 0);
  }
  function closeLB() {
    if (!lb.classList.contains("is-open")) return;
    lb.classList.remove("is-open");
    ilImg.src = "";
    document.body.style.overflow = "";
  }

  main.addEventListener("click", openLB);

  /* v71: mobile zoom button — opens the same lightbox at the slide
     currently in the viewport (mobile gallery is scroll-snap based) */
  var mzBtn = document.querySelector(".mzoom-btn"),
      mSlides = document.querySelector(".gallery-mslides");
  if (mzBtn && mSlides) {
    mzBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      collect();
      if (!sources.length) return;
      var i = Math.round(mSlides.scrollLeft / Math.max(1, mSlides.clientWidth));
      lb.classList.add("is-open");
      document.body.style.overflow = "hidden";
      show(Math.min(i, sources.length - 1));
    });
  }

  lb.addEventListener("click", function (e) { if (e.target === lb) closeLB(); });
  var c = lb.querySelector(".il-close");
  if (c) c.addEventListener("click", closeLB);
  var pv = lb.querySelector(".il-arrow.prev"), nx = lb.querySelector(".il-arrow.next");
  if (pv) pv.addEventListener("click", function (e) { e.stopPropagation(); show(cur - 1); });
  if (nx) nx.addEventListener("click", function (e) { e.stopPropagation(); show(cur + 1); });
  document.addEventListener("keydown", function (e) {
    if (!lb.classList.contains("is-open")) return;
    if (e.key === "Escape") closeLB();
    if (e.key === "ArrowLeft") show(cur - 1);
    if (e.key === "ArrowRight") show(cur + 1);
  });
  /* ------------------------------------------------------------------
     PINCH ZOOM AND PAN INSIDE THE LIGHTBOX  (v105)

     THE BUG (recorded by the client)
     The lightbox had no zoom of its own, so pinching a product photo on a
     phone triggered the BROWSER's page zoom. The lightbox is position:fixed,
     which pins it to the layout viewport while pinching moves the visual
     viewport — the picture slid out from under the visitor's fingers, they
     ended up on a blank corner or the bare edge of a frame, and the close
     button was off-screen. The only way out was to reload.

     THE FIX
     Handle the gesture here and keep the browser out of it. Panning is
     clamped to the image's own edges, which is what makes the dead end
     impossible: the picture cannot be dragged into empty space, and it
     always returns to 1:1 on close or when changing image.
     ------------------------------------------------------------------ */
  var MAX = 4, MIN = 1;
  var scale = 1, tX = 0, tY = 0;
  var startD = 0, startScale = 1, startX = 0, startY = 0, panX = 0, panY = 0;
  var pointers = new Map();
  var lastTap = 0, moved = false;

  function apply(animate) {
    ilImg.style.transition = animate ? "transform .25s ease" : "none";
    ilImg.style.transform = "translate(" + tX + "px," + tY + "px) scale(" + scale + ")";
    lb.classList.toggle("is-zoomed", scale > 1.01);
  }
  function clamp() {
    var r = ilImg.getBoundingClientRect();
    var w = r.width / scale, h = r.height / scale;
    var maxX = Math.max(0, (w * scale - Math.min(w * scale, lb.clientWidth)) / 2);
    var maxY = Math.max(0, (h * scale - Math.min(h * scale, lb.clientHeight)) / 2);
    tX = Math.max(-maxX, Math.min(maxX, tX));
    tY = Math.max(-maxY, Math.min(maxY, tY));
  }
  function reset(animate) { scale = 1; tX = 0; tY = 0; apply(animate); }
  function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }

  lb.addEventListener("pointerdown", function (e) {
    if (e.target.closest(".il-close, .il-arrow")) return;
    pointers.set(e.pointerId, e);
    moved = false;
    if (pointers.size === 2) {
      var p = Array.from(pointers.values());
      startD = dist(p[0], p[1]); startScale = scale;
    } else if (pointers.size === 1) {
      startX = e.clientX; startY = e.clientY; panX = tX; panY = tY;
    }
  });

  lb.addEventListener("pointermove", function (e) {
    if (!pointers.has(e.pointerId)) return;
    pointers.set(e.pointerId, e);
    var p = Array.from(pointers.values());
    if (p.length === 2 && startD > 0) {
      e.preventDefault();
      scale = Math.max(MIN, Math.min(MAX, startScale * (dist(p[0], p[1]) / startD)));
      if (scale <= 1.01) { tX = 0; tY = 0; }
      clamp(); apply(false); moved = true;
      return;
    }
    if (p.length === 1 && scale > 1.01) {
      e.preventDefault();
      tX = panX + (e.clientX - startX);
      tY = panY + (e.clientY - startY);
      clamp(); apply(false); moved = true;
    }
  });

  function endPointer(e) {
    pointers.delete(e.pointerId);
    if (pointers.size < 2) startD = 0;
    if (!moved && e.type === "pointerup" && !e.target.closest(".il-close, .il-arrow")) {
      var now = Date.now();
      if (now - lastTap < 300) {
        if (scale > 1.01) { reset(true); }
        else {
          scale = 2.5;
          var r = ilImg.getBoundingClientRect();
          tX = (r.left + r.width / 2 - e.clientX) * (scale - 1);
          tY = (r.top + r.height / 2 - e.clientY) * (scale - 1);
          clamp(); apply(true);
        }
        lastTap = 0;
      } else { lastTap = now; }
    }
  }
  lb.addEventListener("pointerup", endPointer);
  lb.addEventListener("pointercancel", endPointer);

  /* swipe between images only while not zoomed, and only for mostly
     horizontal drags, so a scroll attempt does not skip an image */
  var tapDX = null, tapDY = null;
  lb.addEventListener("touchstart", function (e) {
    if (e.touches.length !== 1 || scale > 1.01) { tapDX = null; return; }
    tapDX = e.touches[0].clientX; tapDY = e.touches[0].clientY;
  }, { passive: true });
  lb.addEventListener("touchend", function (e) {
    if (tapDX === null || scale > 1.01) { tapDX = null; return; }
    var dx = e.changedTouches[0].clientX - tapDX;
    var dy = e.changedTouches[0].clientY - tapDY;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1));
    tapDX = null;
  }, { passive: true });

  var _show = show;  show = function (i) { _show(i); reset(false); };
  var _close = closeLB; closeLB = function () { reset(false); _close(); };
  lb.addEventListener("dblclick", function (e) {
    if (!e.target.closest(".il-close, .il-arrow")) e.preventDefault();
  });
})();

/* ---------- Map drag hint dismiss ---------- */
(function () {
  "use strict";
  /* Centre the scrollable map on India when the page opens (mobile) */
  function centreMap() {
    document.querySelectorAll(".imap-mscroll").forEach(function (f) {
      var c = f.querySelector(".imap-canvas");
      if (!c || f.scrollWidth <= f.clientWidth) return;
      /* India's landmass centre sits at ~46% of the artwork width */
      f.scrollLeft = Math.max(0, c.offsetWidth * 0.46 - f.clientWidth / 2);
    });
  }
  centreMap();
  window.addEventListener("load", centreMap);
  document.querySelectorAll(".imap-mscroll").forEach(function (f) {
    var h = f.querySelector(".imap-drag-hint");
    if (!h) return;
    var done = false;
    function kill() {
      if (done) return;
      done = true;
      h.classList.add("is-done");
      setTimeout(function () { if (h.parentNode) h.parentNode.removeChild(h); }, 450);
    }
    var armed = false;
    setTimeout(function () { armed = true; }, 600);
    f.addEventListener("scroll", function () { if (armed) kill(); }, { passive: true });
    setTimeout(kill, 6000);
  });
})();

/* ---------- Swipe dots for image sliders (cards + mobile gallery) ---------- */
(function () {
  function buildDots(slider) {
    var n = slider.children.length;
    if (n < 2 || slider.dataset.dotsDone) return;
    slider.dataset.dotsDone = "1";
    var wrap = document.createElement("div");
    wrap.className = "slide-dots";
    for (var i = 0; i < n; i++) {
      var d = document.createElement("span");
      if (i === 0) d.className = "is-on";
      wrap.appendChild(d);
    }
    var host = slider.parentElement;
    if (getComputedStyle(host).position === "static") host.style.position = "relative";
    host.appendChild(wrap);
    var ticking = false;
    slider.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(slider.scrollLeft / slider.clientWidth);
        var dots = wrap.children;
        for (var k = 0; k < dots.length; k++) dots[k].classList.toggle("is-on", k === Math.min(i, dots.length - 1));
      });
    }, { passive: true });
  }
  function init() {
    /* Waypoint: product-card swipe dots removed on mobile per client request.
       Swipe still works (CSS scroll-snap); we simply no longer build the dots. */
    return;
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  window.addEventListener("resize", init, { passive: true });
})();

/* ---------- Site-wide scroll progress bars (v66) ---------- */
(function () {
  "use strict";

  function makeBar() {
    var bar = document.createElement("div");
    bar.className = "tscroll-progress";
    bar.setAttribute("aria-hidden", "true");
    bar.appendChild(document.createElement("span"));
    return bar;
  }

  /* Scroll-based sliders: bar tracks scrollLeft */
  var SCROLL_TARGETS = [
    ".ftabs-row",
    ".states-grid",
    ".cc-scroll .circle-grid",
    ".ig-reels__row",
    ".gallery-mslides",
    ".imap-mscroll"
  ];

  function bindScroll(el) {
    if (el.dataset.tspDone) return;
    el.dataset.tspDone = "1";
    var bar = makeBar();
    el.insertAdjacentElement("afterend", bar);
    var fill = bar.firstChild;
    var ticking = false;

    function update() {
      var max = el.scrollWidth - el.clientWidth;
      if (max <= 2) { bar.classList.add("is-hidden"); return; }
      bar.classList.remove("is-hidden");
      var pct = el.scrollLeft / max;
      var base = el.clientWidth / el.scrollWidth;
      fill.style.width = (base + (1 - base) * pct) * 100 + "%";
    }
    el.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function initAll(scope) {
    scope = scope || document;
    SCROLL_TARGETS.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(bindScroll);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
/* v96d removed in v109 — it injected a close button into .filters-head and
   bound its own outside-click and Escape handlers. The drawer above now ships
   a real close button and owns those handlers, and two sets of listeners on
   the same panel meant a click could open and immediately close it. */